import AccountDetails from './AccountDetails'

export default AccountDetails
